// extracted by mini-css-extract-plugin
export default {"iconContainer":"MultiIcon_iconContainer__Q2tfh","icon":"MultiIcon_icon__7eXS2"};